/**
 * Represents an insurance option.
 *
 * @author brianh2
 */
import React, { Component } from 'react';
import { getInsuranceProviderDisplayName } from '../util/gearOrderUtil';

class InsuranceOption extends Component {

	render() {
		let option = this.props.option;
		const providerName = option.otherProvider || getInsuranceProviderDisplayName(option.insuranceProvider);
		return (
			<span>
				<button type="button" className="btn btn-primary" onClick={() => {this.props.select(option)}}   >
					{providerName} - {option.subscriberId}
				</button>
				&nbsp;
			</span>
		);
	}
}
export default InsuranceOption;